// extracted by mini-css-extract-plugin
export default {"nav":"nav_nav__A+Z1L","img-icon":"nav_img-icon__gz+os","sticky-nav":"nav_sticky-nav__XtEmG","svg-container":"nav_svg-container__FiMBz","svg-img-logo":"nav_svg-img-logo__Wh5ZK"};